import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Segment, Sticky, Grid, Divider } from 'semantic-ui-react';
import { Button, List, Checkbox, Container, Form, Icon, Modal, Progress } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import PageHeader from './PageHeader'
import { AppState } from '../context';
import { dbCaregivers, dbFamMember, dbPending, dbFamtoFam, dbTasks } from '../firebase';
import firebase from 'firebase/app';
import 'firebase/functions';
import Cookies from 'js-cookie';
const Recommended = ({inst}) => {
  const { userid } = useParams();
  const [breakfast, setBreakfast] = useState(false);
  const [lunch, setLunch] = useState(false);
  const [shower, setShower] = useState(false);
  const [toileting, setToileting] = useState(false);
  const [oralcare, setoralcare] = useState(false)
  const someContext = useContext(AppState);
  const {
    pending,
    correct,
    setCorrect,
    familyMembers,
    seniors,
    tasks,
    caregivers,
    admin
  } = someContext;

  function WriteFirebase() {
    if (familyMembers) {
      // familyMembers[userid]['caregivers']
      if (familyMembers[userid]['careBool']) {
        // only adds the tasks if you have a caregiver
        var caregiverID = familyMembers[userid]['caregivers'][0];
        var seniorID;
        if (familyMembers[userid] && familyMembers[userid]['seniors']) {
          seniorID = familyMembers[userid]['seniors'][0];
        }
        else {
          seniorID = "null"
        }

        var msg = "Check with " + familyMembers[userid]['firstName'] + " for what temperature water to use!";
        if (shower) {
          const k = dbTasks.push({
            "description": msg,
            "familyMemberID": userid,
            "frequency": "Everyday",
            "importance": "High",
            "status": false,
            "taskName": "Shower/Bathing",
            "time": "10 am",
            "caregiverId": caregiverID,
            "seniorID": seniorID,
            "createdOn": { '.sv': 'timestamp' }
          })
          let push = k.path['pieces_'][1];

          dbFamMember.child(userid).child("tasks").update({
            [push]: push || null
          });
          dbCaregivers.child(caregiverID).child("tasks").update({
            [push]: push || null
          });

        }
        if (breakfast) {
          var msg2 = "Check with " + familyMembers[userid]['firstName'] + " for what food to prepare please!";

          const k = dbTasks.push({
            "description": msg2,
            "familyMemberID": userid,
            "frequency": "Everyday",
            "importance": "High",
            "status": false,
            "taskName": "Breakfast",
            "time": "8 am",
            "caregiverId": caregiverID,
            "seniorID": seniorID,
            "createdOn": { '.sv': 'timestamp' }
          })
          let push = k.path['pieces_'][1];

          dbFamMember.child(userid).child("tasks").update({
            [push]: push || null
          });
          dbCaregivers.child(caregiverID).child("tasks").update({
            [push]: push || null
          });

        }
        if (lunch) {
          var msg2 = "Check with " + familyMembers[userid]['firstName'] + " for what food to prepare please!";

          const k = dbTasks.push({
            "description": msg2,
            "familyMemberID": userid,
            "frequency": "Everyday",
            "importance": "High",
            "status": false,
            "taskName": "Lunch",
            "time": "12 pm",
            "caregiverId": caregiverID,
            "seniorID": seniorID,
            "createdOn": { '.sv': 'timestamp' }
          })
          let push = k.path['pieces_'][1];

          dbFamMember.child(userid).child("tasks").update({
            [push]: push || null
          });
          dbCaregivers.child(caregiverID).child("tasks").update({
            [push]: push || null
          });

        }
        if (toileting) {
          // if (seniors) {
          //   var msg2 = "Careful to ensure " + seniors[seniorID]['firstName'] + " does not slip!";
          // }
          var msg2 = "Be careful";

          const k = dbTasks.push({
            "description": msg2,
            "familyMemberID": userid,
            "frequency": "Everyday",
            "importance": "High",
            "status": false,
            "taskName": "Toileting",
            "time": " 9 am",
            "caregiverId": caregiverID,
            "seniorID": seniorID,
            "createdOn": { '.sv': 'timestamp' }
          })
          let push = k.path['pieces_'][1];

          dbFamMember.child(userid).child("tasks").update({
            [push]: push || null
          });
          dbCaregivers.child(caregiverID).child("tasks").update({
            [push]: push || null
          });

        }
        if (oralcare) {
          // if (seniors) {
          //   var msg2 = "Careful to ensure " + seniors[seniorID]['firstName'] + " does not brush too hard!";
          // }

          var msg2 = "Make sure to floss";



          const k = dbTasks.push({
            "description": msg2,
            "familyMemberID": userid,
            "frequency": "Everyday",
            "importance": "High",
            "status": false,
            "taskName": "Oral Care (Brushing)",
            "time": " 7:55 am",
            "caregiverId": caregiverID,
            "seniorID": seniorID,
            "createdOn": { '.sv': 'timestamp' }
          })
          let push = k.path['pieces_'][1];

          dbFamMember.child(userid).child("tasks").update({
            [push]: push || null
          });
          dbCaregivers.child(caregiverID).child("tasks").update({
            [push]: push || null
          });
        }
      }
    }
  }


  return (
    <div>
      {inst ? <PageHeader inst={inst} /> :  <PageHeader inst={inst} />}
      <Divider hidden />
      <Grid textAlign='center' style={{ height: '10vh' }} padded>
        <Grid.Row>
          <Grid.Column style={{ marginLeft: "30px", marginRight: "30px", maxWidth: 450 }}>
            <Progress percent={100} indicating />
          </Grid.Column>
        </Grid.Row>

        <Container>



          <Header textAlign="center" content='What are some daily tasks for your caregiver?' />

          <List relaxed selection >
            <List.Item>
              <List.Icon>
                <Checkbox checked={breakfast} onClick={() => setBreakfast(!breakfast)} />
              </List.Icon>
              <List.Content>
                <List.Header > Breakfast</List.Header></List.Content>
            </List.Item>
            <br />
            <List.Item>
              <List.Icon>
                <Checkbox checked={lunch} onClick={() => setLunch(!lunch)} />
              </List.Icon>
              <List.Content>
                <List.Header > Lunch</List.Header></List.Content>
            </List.Item>
            <br />
            <List.Item>
              <List.Icon>
                <Checkbox checked={shower} onClick={() => setShower(!shower)} />
              </List.Icon>
              <List.Content>
                <List.Header > Shower</List.Header></List.Content>
            </List.Item>
            <br />
            <List.Item>
              <List.Icon>
                <Checkbox checked={toileting} onClick={() => setToileting(!toileting)} />
              </List.Icon>
              <List.Content>
                <List.Header > Toileting</List.Header>
              </List.Content>
            </List.Item>
            <br />
            <List.Item>
              <List.Icon>
                <Checkbox checked={oralcare} onClick={() => setoralcare(!oralcare)} />
              </List.Icon>
              <List.Content>
                <List.Header > Oralcare</List.Header>
              </List.Content>
            </List.Item>
          </List>
          <Header as={'h4'} textAlign="center" content='We will add  these automatically as everyday tasks to save you time! But go edit the times that these tasks should happen on the summary page.' />

          <Grid.Row>
            <Grid.Column width={6}>
              <Button color='teal' fluid
                size='large'
                as={Link}
                // to={`/familymembers/summary/${userid}`}
                to={(admin == 'Samarth' || (Cookies.get('logged') == 'Samarth')) ? "/samarth/admin" : `/familymembers/summary/${userid}`}

                onClick={() => WriteFirebase()} >
                Continue
        </Button>
            </Grid.Column>
          </Grid.Row>
        </Container>
      </Grid>

    </div>
  )
}
export default Recommended;

